// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"dK-z","carouselContainer":"eK-z"};